export default "__VITE_ASSET__BaEPXevo__"